import { FC, useState, useContext } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Grid, makeStyles, useMediaQuery } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { useTheme } from "@material-ui/core";
import Lock from "../../assets/images/icons/lock-grey.svg";
import { Button } from "@material-ui/core";
import { TwoFAStyle } from "../Styles/ProfilePagesStyles";
import AuthenticationModal from "../Modals/AuthenticationModal";
import DisableAuthenticationModal from "../Modals/DisableAuthenticationModal";

import Switch from "@material-ui/core/Switch";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AuthIcon from "../../assets/images/2fIcon.png";
import shield from "../../assets/images/shield.png";
import AuthContext from "../../store/Auth/AuthContext";
const Lockimg = () => {
  return <img src={Lock} className="img-fluid" alt="Gains" />;
};

const TwoFactorTab: FC = () => {
  const classes = TwoFAStyle();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const {get2faEnableCode, getProfileData} = useContext<any>(AuthContext)
  const [open, setOpen] = useState(false);

  const [checked, setChecked] = useState(false);
  const toggleChecked = () => {
    setOpen(true);
    // setChecked((prev) => !prev);
    get2faEnableCode();
  };

  const toggleDisabled = () =>{
    setOpen(true);
  }

  const handleAuthentication = (event: any) => {
    event.preventDefault();
    setOpen(true);
    get2faEnableCode();
  };




  return (
    <Box className={classes.root} mt={isActive ? 3 : 5}>
      <Grid>
        <Grid item md={7}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="h3" color="secondary">
              Two Factor Authentication
            </Typography>
          </Box>
          <Typography
            className="text-darkslate"
            variant="body1"
            color="secondary"
          >
            Protect your account from potential intruders, and uninvited guests.{" "}
            <Typography
              className="fw-bold"
              variant="body1"
              component="span"
              color="primary"
            >
              2FA
            </Typography>{" "}
            provides you with an extra layer or security. Next time you login to your
            account, you will be provided both your{" "}
            <Typography
              className="fw-bold"
              variant="body1"
              component="span"
              color="primary"
            >
              Password
            </Typography>{" "}
            and{" "}
            <Typography
              className="fw-bold"
              variant="body1"
              component="span"
              color="primary"
            >
              Authentication
            </Typography>{" "}
            code that you will receive from your phone.
          </Typography>
          <Box mt={2} ml="12px">
            <FormGroup>
              <FormControlLabel
                control={
                  getProfileData?.isTwoFaEnabled ===true ? (
                  <Switch
                    checked
                    onChange={toggleDisabled}
                    icon={<img src={shield} alt="gains" />}
                    checkedIcon={<img src={shield} alt="gains" />}
                  />
                  ): (
                    <Switch
                    checked={false}
                    onChange={toggleChecked}
                    icon={<img src={AuthIcon} alt="gains" />}
                    checkedIcon={<img src={AuthIcon} alt="gains" />}
                    />
                  )
                  
                }
                label={<Box ml={2} className={getProfileData?.isTwoFaEnabled ? classes.profileSuccess: classes.profileError }>{getProfileData?.isTwoFaEnabled ===true ? "Enabled" : "Disabled"}</Box>}
              />
            </FormGroup>
          </Box>
          <Button
            variant="outlined"
            color="secondary"
            className="auth-btn"
            size="large"
            onClick={handleAuthentication}
          >
            Google Authenticator
          </Button>
          {getProfileData?.isTwoFaEnabled === false  ? (
            <AuthenticationModal open={open} setOpen={setOpen} />
          ) : (
            <DisableAuthenticationModal open={open} setOpen={setOpen} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TwoFactorTab;
